import { useLocale, useTranslations } from 'next-intl';
import React from 'react';
import Image from 'next/image';
// import { Input } from '@/components/ui/input';
// import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
// import { AlertCircle } from 'lucide-react';

const AddCustomerService = () => {
  const t = useTranslations();
  const currentLocale = useLocale();

  // const [open, setOpen] = useState<boolean>(false);
  // const [name, setName] = useState<string>('');
  // const [email, setEmail] = useState<string>('');
  // const [contact, setContact] = useState<string>('');
  // const [wechat, setWechat] = useState<string>('');
  // const typeList = ['移民评估', '留学评估', '签证评估', '旅游需求'];
  // const [activeType, setActiveType] = useState<string>('移民评估');
  // const [text1, setText1] = useState<string>('');
  // const [text2, setText2] = useState<string>('');
  // const [text3, setText3] = useState<string>('');
  // const [text4, setText4] = useState<string>('');
  // const [showAlert, setShowAlert] = useState<boolean>(false);

  // const handleSubmit = () => {
  //   if (!email) {
  //     setShowAlert(true);
  //     return;
  //   }
  // };

  return (
    <div
      id="addCustomerServiceBox"
      className="box-border flex h-[11.44vw] w-full flex-row items-center justify-between bg-[#2A2B45] px-[12.584vw] max-md:m-0 max-md:min-h-[250px] max-md:flex-col max-md:justify-center"
    >
      <div className="flex flex-row items-center justify-center max-md:flex-col">
        <div className="mr-[2.548vw] w-[21.84vw] text-[1.456vw] leading-normal text-white max-md:m-0 max-md:mb-[15px] max-md:w-full max-md:text-lg max-md:leading-[18px]">
          {t('AddCustomerService.title')}
        </div>
        <div
          className="box-border flex w-[15.6vw] cursor-pointer flex-row items-center justify-center border-[2px] border-solid border-white px-[1.328vw] py-[1.04vw] text-center text-[1.456vw] leading-[1.456vw] text-white max-md:mb-7 max-md:h-10 max-md:w-[150px] max-md:text-sm max-md:leading-normal"
          onClick={() => {
            // setOpen(true);
            // setShowAlert(false);
            window.open(process.env.NEXT_PUBLIC_WEBSITE + '/%E5%BF%AB%E9%80%9F%E8%AF%84%E4%BC%B0%E8%A1%A8/', '_blank');
          }}
        >
          {t('AddCustomerService.buttonText')}
        </div>
      </div>
      <div
        style={{ background: 'linear-gradient(0deg, #FFB341 0%, #FFDC93 100%)' }}
        className="flex h-[8.01vw] w-[22.88vw] flex-row items-center justify-center rounded-[10px] px-[1.32vw] max-md:h-[77px] max-md:w-[220px] max-md:px-4"
      >
        <div className="box-border flex w-full flex-col items-start justify-between">
          <div
            className={`mb-[0.832vw] text-left font-medium text-[#2A2B45] max-md:mb-2 ${currentLocale === 'zh' ? 'text-[1.472vw] leading-[1.472vw] max-md:text-sm' : 'pr-[0.52vw] text-[1.072vw] leading-[1.372vw] max-md:text-xs max-md:leading-tight'}`}
          >
            {t('AddCustomerService.buttonText1')}
          </div>
          <div className="flex flex-row items-center justify-start">
            <Image
              src="/images/home/customerService.png"
              alt=""
              width={40}
              height={40}
              className="mr-[0.832vw] size-[2.08vw] rounded-full max-md:mr-2 max-md:size-5"
            />
            <div className="text-[0.832vw] leading-[0.832vw] text-[#2A2B45] max-md:text-[10px] max-md:leading-normal">
              starringca002
            </div>
          </div>
        </div>
        <Image src="/images/home/qrcode1.png" alt="" width={40} height={40} className="size-[5.8vw] max-md:size-12" />
      </div>
    </div>
  );
};

export default AddCustomerService;
